export default function delayedBoundsCall(cb: Function) {
  cb();
  setTimeout(cb, 250);
}
